<template>
    <el-container class="layout-container">
        <!-- 顶部导航 -->
        <el-header class="app-header">
            <!-- 平台名：背景图中烙印文字已修除，改用 HTML 文字渲染（更清晰） -->
            <div class="app-logo">{{ platformName }}</div>
            <!-- 页面标题：紧跟 logo 区块右侧，样式对齐大屏顶部导航项（图标 + 渐变文字） -->
            <div class="app-page-title" v-if="pageTitle">
                <img class="apt-icon" v-if="pageTitleIcon" :src="pageTitleIcon" alt="" />
                {{ pageTitle }}
            </div>
            <Header @reset-password="showResetPassword" />
        </el-header>

        <!-- 主体内容区 -->
        <el-container class="main-container">
            <!-- 侧边栏 -->
            <el-aside width="430px" class="app-aside">
                <Menu />
            </el-aside>

            <!-- 主内容区 -->
            <el-main class="app-main">
                <div class="cont">
                    <router-view v-slot="{ Component }">
                        <transition name="slide-fade">
                            <component :is="Component" />
                        </transition>
                    </router-view>
                </div>
            </el-main>
        </el-container>

        <!-- 密码重置弹窗 -->
        <ResetPassword :show="modal1" @on-close="modal1 = false" />
    </el-container>
</template>

<script>
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import { mapMutations } from 'vuex'
import ResetPassword from './ResetPassword.vue'
export default {
    components: {
        Menu,
        Header,
        ResetPassword
    },
    data() {
        return {
            modal1: false,
        }
    },
    computed: {
        platformName() {
            return (typeof window !== 'undefined' && window.mconfig && (window.mconfig.name || window.mconfig.nav_title)) || '智慧教研平台'
        },
        pageTitle() {
            const map = {
                '/teacher': '教师列表',
                '/auto': '评课管理',
                '/module': '评课标准',
                '/module/rule': '指标项',
            };
            return map[this.$route.path] || '';
        },
        pageTitleIcon() {
            const map = {
                '/teacher': 'icon-tc.png',
                '/auto': 'icon-pk.png',
                '/module': 'icon-kc.png',
                '/module/rule': 'icon-kc.png',
            };
            const f = map[this.$route.path]
            return f ? require('../assets/header/' + f) : ''
        }
    },
    mounted() {
    },
    methods: {
        ...mapMutations(['logout']),
        showResetPassword() {
            this.modal1 = true
        }
    }
}
</script>

<style scoped lang="less">
// 基础样式变量
@header-height: 72px; // 顶部高度
@aside-width: 400px; // 侧边栏宽度

// 清除可能导致蒙层的全局样式
* {
    box-shadow: none !important;
    outline: none !important;
    border: none !important;
}

// 自定义滚动条样式
/deep/ ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

/deep/ ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

/deep/ ::-webkit-scrollbar-track {
    background: transparent;
}

// Element UI 组件样式覆盖
/deep/ .el-pagination.is-background .el-pager li {
    height: 32px;
    width: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background-color: transparent;
    font-weight: 400;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: transparent;
    border-color: #2d8cf0;
    color: #2d8cf0;
}

/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .btn-next {
    background-color: transparent;
    width: 32px;
    height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    font-weight: 400;
}

/deep/ .el-pagination .el-select .el-input {
    width: 80px;
}

/deep/ .el-input--mini .el-input__inner {
    height: 32px;
    border-radius: 4px;
}

/deep/ .el-upload {
    display: block;
}

/deep/ .el-upload-dragger {
    width: 100%;
}


// 头部样式
.app-header {
    height: @header-height !important;
    background: transparent;
    padding: 0 20px;
    line-height: @header-height;
    position: relative;
}

// 顶栏左侧平台名（背景图中原有烙印文字已修除，此处按烙印原字号 44px/1920 渲染，仅更清晰）
// 背景 100% 100% 拉伸：色带中心 = 39/1080 ≈ 3.6vh，随窗口高度自适应，避免字垂出色带
.app-logo {
    position: absolute;
    left: 1.4%;
    top: 3.6vh;
    transform: translateY(-50%);
    z-index: 6;
    pointer-events: none;
    white-space: nowrap;
    line-height: 1;
    font-size: 2.3vw; // 44 / 1920，与原背景图烙印字号一致
    font-weight: 600;
    letter-spacing: 0.65em;
    color: #f2f9ff;
    text-shadow: 0 0 14px rgba(64, 156, 255, 0.55);
}

// 页面标题：logo 区块右侧（斜切边 ~32% 之后），样式对齐大屏顶部导航项（渐变填充文字）
.app-page-title {
    position: absolute;
    left: 33.5%;
    top: 3.6vh;
    transform: translateY(-50%);
    z-index: 5;
    pointer-events: none;
    white-space: nowrap;
    line-height: 1;
    display: flex;
    align-items: center;
    font-size: 1.25vw; // 24 / 1920（比导航项大一号）
    font-weight: 400;
    letter-spacing: 2px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.95), rgba(158, 209, 255, 0.85));
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;

    .apt-icon {
        width: 1.25vw;
        height: 1.25vw;
        margin-right: 0.4vw;
    }
}

// 重置Element UI默认样式
/deep/ .el-header {
    background: transparent !important;
    padding: 0 20px !important;
    height: @header-height !important;
}

// 过渡动画
.slide-fade-enter-active {
    transition: all .8s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
}

// 布局容器样式
.layout-container {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    background-image: url('../assets/home/background.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
}



// 主体容器样式
.main-container {
    flex: 1;
    display: flex;
    min-height: 0;
    // margin-top: 10px;
    /* 防止flex子元素溢出 */
}

// 侧边栏样式
.app-aside {
    width: @aside-width !important;
    background: transparent;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

// 主内容区样式
.app-main {
    flex: 1;
    padding: 0 20px;
    background: transparent;
    overflow: hidden;
    min-height: 0;
    /* 防止flex子元素溢出 */

    .cont {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
    }
}

// 响应式设计
@media (max-width: 990px) {
    .app-aside {
        width: 300px !important;
    }
}

// 重置Element UI默认样式
/deep/ .el-container,
/deep/ .el-header,
/deep/ .el-container,
/deep/ .el-aside,
/deep/ .el-main {
    background: transparent !important;
    padding: 0;
}



/deep/ .el-aside {
    width: @aside-width !important;
}
</style>
